import { useQuery } from 'react-query';

import {
  AccessControlKind,
  accessControlService,
} from '../services/accessControlService';

// Prefixo das chaves: `invalidateQueries(ACCESS_CONTROL_KEY)` atualiza listas,
// contagens e usuários de uma vez depois de qualquer alteração.
export const ACCESS_CONTROL_KEY = 'access-control';

export function useAccessControlItems(kind: AccessControlKind) {
  return useQuery(
    [ACCESS_CONTROL_KEY, 'items', kind],
    () => accessControlService.listItems(kind),
    { staleTime: 60 * 1000, refetchOnWindowFocus: false },
  );
}

export function useAccessControlUsers() {
  return useQuery(
    [ACCESS_CONTROL_KEY, 'users'],
    accessControlService.listUsers,
    { staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false },
  );
}

export function useItemUsers(kind: AccessControlKind, id?: string) {
  return useQuery(
    [ACCESS_CONTROL_KEY, 'item-users', kind, id],
    () => accessControlService.listItemUsers(kind, id as string),
    { enabled: !!id, staleTime: 0, refetchOnWindowFocus: false },
  );
}
